(function () {
  function forceOpen() {
    var host = document.getElementById('search-modal');
    if (!host) {
      try { console.error('[obacco-search] #search-modal missing from DOM'); } catch (_) {}
      return;
    }
    try {
      if (typeof host.showDialog === 'function') {
        host.showDialog();
        return;
      }
    } catch (_) {}
    var dlg = host.querySelector('dialog');
    if (dlg && !dlg.open) {
      try { dlg.showModal(); } catch (_) {}
    }
  }

  document.addEventListener('click', function (e) {
    var btn = null;
    try { btn = e.target && e.target.closest ? e.target.closest('search-button button') : null; } catch (_) {}
    if (!btn) return;
    setTimeout(function () {
      var dlg = document.querySelector('#search-modal dialog');
      if (!dlg || !dlg.open) forceOpen();
    }, 60);
  });
})();
